import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileStickyBar } from './components/MobileStickyBar';
import { HomePage } from './pages/HomePage';
import { ServicePage } from './pages/ServicePage';
import { ServicesPage } from './pages/ServicesPage';
import { CommercialPage } from './pages/CommercialPage';
import { CommercialServicePage } from './pages/CommercialServicePage';
import { CityPage } from './pages/CityPage';
import { ServiceAreasPage } from './pages/ServiceAreasPage';
import { StormDamagePage } from './pages/StormDamagePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { GalleryPage } from './pages/GalleryPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { FinancingPage } from './pages/FinancingPage';
import { BlogPage } from './pages/BlogPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col font-body bg-white" data-id="element-1">
        <Header data-id="element-2" />

        <main className="flex-grow pt-[72px] md:pt-[88px]" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/services" element={<ServicesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/services/:slug" element={<ServicePage data-id="element-10" />} data-id="element-9" />
            <Route path="/commercial" element={<CommercialPage data-id="element-12" />} data-id="element-11" />
            <Route path="/commercial/:slug" element={<CommercialServicePage data-id="element-14" />} data-id="element-13" />
            <Route path="/areas" element={<ServiceAreasPage data-id="element-16" />} data-id="element-15" />
            <Route path="/area/:slug" element={<CityPage data-id="element-18" />} data-id="element-17" />
            <Route path="/gallery" element={<GalleryPage data-id="element-20" />} data-id="element-19" />
            <Route path="/reviews" element={<ReviewsPage data-id="element-22" />} data-id="element-21" />
            <Route path="/about" element={<AboutPage data-id="element-24" />} data-id="element-23" />
            <Route path="/contact" element={<ContactPage data-id="element-26" />} data-id="element-25" />
            <Route path="/financing" element={<FinancingPage data-id="element-28" />} data-id="element-27" />
            <Route path="/blog" element={<BlogPage data-id="element-30" />} data-id="element-29" />
            <Route path="/storm-damage" element={<StormDamagePage data-id="element-32" />} data-id="element-31" />
          </Routes>
        </main>

        <Footer data-id="element-33" />
        <MobileStickyBar data-id="element-34" />
      </div>
    </BrowserRouter>;
}